<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 895.996 752.825">
  <path
    data-player="true"
    fill="#808080"
    d="m223.43 0 44.297 161.36L2.16 143.07c-.76 0-1.39-1.95-2.16-1.89L223.43 0Zm672.566 146.85H629.829L673.129 0l222.867 146.85Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M628.833 161.36H267.727L223.43 0h449.699l-44.296 161.36Z"
  />
  <path
    data-player="true"
    fill="#333333"
    d="M628.833 161.36H267.727L223.43 0h449.699l-44.296 161.36Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M629.829 146.85 451.573 752.825 268.345 143.07l361.484 3.78Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="m268.345 143.07 183.228 609.755L2.16 143.07h266.185Z"
  />
  <path
    data-player="true"
    fill="#333333"
    d="m268.345 143.07 183.228 609.755L2.16 143.07h266.185Z"
  />
  <path
    data-player="true"
    fill="#808080"
    d="M629.829 146.85h266.167L451.573 752.825 629.829 146.85Z"
  />
  <path
    data-player="true"
    fill="#333333"
    d="M629.829 146.85h266.167L451.573 752.825 629.829 146.85Z"
  />
</svg>
